import { Fragment, useMemo, useState } from 'react';
import { Button } from '@schibsted-svp/react-ui';
import { Link } from 'react-router-dom';

import { Table } from '../Table/Table';

import { ComponentRow } from './ComponentRow/ComponentRow';

import type { ComponentResponse, UserResponse } from '../../types';

import styles from './ComponentsTable.module.scss';

type Props = {
  users: UserResponse[];
  components: ComponentResponse[];
  loading?: boolean;
};

function ComponentsTable({ users, components, loading }: Props) {
  const [filter, setFilter] = useState('');

  const filtered = useMemo(
    () =>
      components.filter((component) => {
        return (
          (component.header && component.header.includes(filter)) ||
          (component.sharedName && component.sharedName.includes(filter))
        );
      }),
    [components, filter]
  );

  return (
    <Fragment>
      <Table
        items={[...filtered]}
        renderHeader={() => (
          <tr>
            <th>Name</th>
            <th>Settings</th>
            <th className={styles.updated}>Last update</th>
          </tr>
        )}
        renderRow={(component) => (
          <ComponentRow
            component={component}
            key={component.id}
            user={users.find(({ email }) => email === component.updatedBy)}
          />
        )}
        renderActions={() => (
          <Link to="/components/new">
            <Button type="button">Create a new component</Button>
          </Link>
        )}
        onFilterChange={setFilter}
        loading={loading}
      />
    </Fragment>
  );
}

export { ComponentsTable };
